"use strict";

canopyPublic.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	$stateProvider.state("public.confirm", {
		url: "/confirm?uuid",
		controller: "ConfirmController",
		templateUrl: Luma.paths.context + "/system/mantle/components/canopyPublic/states/confirm/confirm.template.html"
	});
}]);
